import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import Cookies from "js-cookie";
import { deviceTypes } from "../config/Constant";

// Your web app's Firebase configuration
const REACT_APP_AUTHENTICATION_API_URL =
  process.env.REACT_APP_AUTHENTICATION_API_URL ||
  "https://msgauth.winitech.com:7000";
const firebaseConfig = {
  apiKey: "AIzaSyBaI_aAXzke7rb3-m6uzp7ZQ1ekIQb-Tkw",
  authDomain: "wini-chat.firebaseapp.com",
  projectId: "wini-chat",
  storageBucket: "wini-chat.firebasestorage.app",
  messagingSenderId: "270109894732",
  appId: "1:270109894732:web:3fc0a2b88364dee6b46ce9",
  measurementId: "G-CYCV8D1Y23",
};

// Initialize Firebase
let messaging;
try {
  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
  // Optionally, you can initialize other Firebase services here (e.g., analytics, etc.)
  // const analytics = getAnalytics(app);
} catch (error) {
  console.error("Firebase initialization failed:", error);
  // Optionally, you can provide fallback behavior or just ignore the error.
  // Continue with the rest of your web app as usual
}

// Register Token function
const registerToken = async (userId) => {
  const access_token = Cookies.get("access_token");

  // Ensure messaging was initialized before proceeding
  if (!messaging) {
    console.error("Firebase messaging was not initialized.");
    return;
  }

  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BCa4PxEO1tMnlCLup3EsmbKABcpKryW2yEVLmoHE2aeZQqvC8FnTFehMm5GCC-d5lgUEKAYqt1gVVmQZfh-UkzE",
    });
    const deviceType = deviceTypes.WEB;
    if (token) {
      Cookies.set("fcm_token", token);
      // Register the token with your server
      const response = await axios.post(
        `${REACT_APP_AUTHENTICATION_API_URL}/api/fcm/register-token`,
        { userId, token, deviceType },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      return response;
    } else {
      console.warn("No token received.");
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
  }
};

export { messaging, registerToken };
